import { useEffect } from "react"
import styled from "styled-components"

import { colors } from "@minuthq/meatball-ui-react"

interface MDrawerProps {
  open: boolean
  onClose: () => void
  children: React.ReactNode
}

export function MDrawer({ open, onClose, children }: MDrawerProps) {
  useEffect(() => {
    if (open) {
      document.body.style.overflowY = "hidden"
    } else {
      document.body.style.overflowY = "unset"
    }

    return () => {
      document.body.style.overflowY = "unset"
    }
  }, [open])

  return (
    <div>
      <DrawerContainer $open={open}>{children}</DrawerContainer>
      <Backdrop $hidden={!open} onClick={onClose} />
    </div>
  )
}

const Backdrop = styled.div<{ $hidden: boolean }>`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: ${colors.neutralDark3};

  display: ${({ $hidden }) => ($hidden ? "none" : "block")};
  opacity: 0.5;
  z-index: 1400;
`

const DrawerContainer = styled.div<{ $open: boolean }>`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  background-color: ${colors.neutralLight};
  transform: translateX(${({ $open }) => ($open ? "0" : "100%")});
  transition: transform 0.3s ease-in-out;
  z-index: 1500;
  overflow-y: auto;
`
